import { Class, EntityType } from 'api/v3/aas_core_meta/types';

export function GetEntityType(el: Class) : EntityType {
    try {
        const jsonable = JSON.parse(JSON.stringify(el));

        switch (jsonable.entityType) {
            case 'SelfManagedEntity':
                return EntityType.SelfManagedEntity;
            default:
                return EntityType.CoManagedEntity;
        }
    } catch (error: unknown) {
        return NaN;
    }
}
